module.exports = __webpack_public_path__ + "img/send-screening-icon.74b37697.svg";